import React from "react";
import Loader from "../Common/Loader";

function VendorTransactions({walletTransactions, loading3, loading4}) {
    return (
        <>
            <div className="border-top mt-1"></div>
            <div className="table-responsive">
                {loading3 || loading4 ? (
                    <Loader /> 
                ) : (
                    <table className="table display data-table text-nowrap">
                        <thead>
                            <tr>
                            <th>Transaction Date</th>
                            <th>Amount</th>
                            <th>Transaction Type</th> 
                            <th>Transaction Number</th>
                            
                            </tr>
                        </thead>
                        <tbody>
                            {walletTransactions.length > 0 ? (
                                walletTransactions.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.created_at?.short_date}<br /><small>{item.created_at?.time}</small></td>                                          
                                    
                                    
                                    <td>
                                        <span class="badge bg-teal">
                                            {item.type === "Withdraw"?
                                            <i class="fa fa-circle-arrow-down text-teal fs-9px fa-fw me-5px" style={{ color: "#dc3545" }}></i>:
                                            <i class="fa fa-circle-arrow-up text-teal fs-9px fa-fw me-5px" style={{ color: "#28a745" }}></i>    
                                            }
                                        </span>
                                        UGX.{" "}
                                        {item.amount}<br/>
                                        <small>
                                        {item.description}
                                        </small>
                                        
                                    </td>
                                    <td>
                                        <span class="badge badge-primary">
                                        {item.account}
                                        </span>
                                    </td>
                                    <td>{item.transaction_number}</td>

                                </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center" }}>
                                        No transactions involving this vendor yet.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        
        </>
        
    );
}

export default VendorTransactions;
